// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__cB3AL","cellWithInput":"table_cellWithInput__N6u24"};